import {RestService} from "@/services/rest/RestService";
import {DocumentAPIApi} from "@/api/pharma-master-document";
import {DpExceptions} from "@/error/DpExceptions";

export class DocumentRestService extends RestService {

    private apiService: DocumentAPIApi;

    protected constructor() {
        super();

        this.apiService = new DocumentAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().masterUrl);
    }

    public async findSignedPreviewUrl(documentKey: string, moduleCode: string): Promise<string> {
        const response = await this.apiService.documentV1DocumentDocumentKeySignedUrlGet(moduleCode, documentKey);

        return response.data.signed_url;
    }

    public async findPublicPreviewUrl(documentKey: string, moduleCode: string): Promise<string> {
        const response = await this.apiService.documentV1DocumentDocumentKeyPublicUrlGet(moduleCode, documentKey);

        return response.data.public_url;
    }

    public async uploadFile(typeCode: String, file: File, moduleCode: string): Promise<string|null> {
        const url = this.getConfig().fileUploadUrl.replace('{type_code}', typeCode);
        const formData = new FormData();
        // Create a new file with a sanitized name
        const sanitizedFilename = file.name.replace(/[^a-zA-Z0-9.-]/g, '_');
        const newFile = new File([file], sanitizedFilename, {
            type: file.type,
            lastModified: file.lastModified,
        });
        formData.append('file', newFile);
        const formConfig = {
            headers: {
                'content-type': 'multipart/form-data',
                'x-dp-module-code': moduleCode,
            },
        };

        try {
            const response = await this.getDpAxiosInstance().post(url, formData, formConfig);

            return response?.data?.document_key ?? null;
        } catch (error) {
            if (error instanceof Array) {
                throw new DpExceptions(error);
            }
            throw error;
        }
    }
}
